export default "__VITE_ASSET__es6g9uUR__"